import _regenerator from "/var/lib/jenkins/workspace/edu-main-ui-pre/node_modules/@babel/runtime/helpers/esm/regenerator.js";
import _asyncToGenerator from "/var/lib/jenkins/workspace/edu-main-ui-pre/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.array.concat.js";
import { unref as _unref, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, createVNode as _createVNode, withCtx as _withCtx } from "vue";
var _hoisted_1 = {
  class: "practice-body"
};
var _hoisted_2 = {
  key: 0,
  class: "practice-list"
};
var _hoisted_3 = ["onClick"];
var _hoisted_4 = {
  class: "item-title"
};
var _hoisted_5 = {
  key: 0,
  class: "item-status"
};
var _hoisted_6 = {
  key: 1,
  class: "no-data"
};
var _hoisted_7 = {
  key: 2
};
import { toRefs, ref, watch, computed } from 'vue';
import { getCourseReviewInfo } from '@/api/index-gai';
import { MessagePlugin } from 'tdesign-vue-next';
import { skipUrl as skipUrlOpen } from '@/util/util';
import useUserStore from '@/stores/modules/user';
import { storeToRefs } from 'pinia';
export default {
  __name: 'ReviewDialog',
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    item: {
      type: Object,
      default: function _default() {}
    }
  },
  emits: ['update:visible'],
  setup: function setup(__props, _ref) {
    var __emit = _ref.emit;
    var _storeToRefs = storeToRefs(useUserStore()),
      appAliasUrl = _storeToRefs.appAliasUrl;
    var props = __props;
    var emit = __emit;
    var _toRefs = toRefs(props),
      visible = _toRefs.visible,
      item = _toRefs.item;
    var listData = ref([]);
    var activeIndex = ref(null);
    var isLoading = ref(false);
    var isEmpty = computed(function () {
      return !isLoading.value && listData.value.length === 0;
    });
    var changeItem = function changeItem(row, index) {
      var _item$value = item.value,
        courseId = _item$value.courseId,
        groupId = _item$value.groupId;
      var paperId = row.paperId;
      activeIndex.value = index;
      var url = "".concat(appAliasUrl.value, "?prepareLesson=/exercise/readOver/1/").concat(paperId, "/").concat(groupId, "/").concat(courseId);
      skipUrlOpen(url, '_blank');
    };
    var hclose = function hclose() {
      emit('update:visible', false);
    };
    watch(function () {
      return visible.value;
    }, function (val) {
      if (val) initData();
    }, {
      deep: true
    });
    /**
     * 获取数据
     */
    var initData = /*#__PURE__*/function () {
      var _ref2 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
        var _item$value2, courseId, groupId, res, _res$data, code, data, _t;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.p = _context.n) {
            case 0:
              isLoading.value = true;
              _context.p = 1;
              _item$value2 = item.value, courseId = _item$value2.courseId, groupId = _item$value2.groupId;
              _context.n = 2;
              return getCourseReviewInfo(courseId, groupId);
            case 2:
              res = _context.v;
              _res$data = res.data, code = _res$data.code, data = _res$data.data;
              if (code === 0) {
                listData.value = data || [];
              }
              _context.n = 4;
              break;
            case 3:
              _context.p = 3;
              _t = _context.v;
              MessagePlugin.error(_t.massage || '获取失败');
            case 4:
              _context.p = 4;
              isLoading.value = false;
              return _context.f(4);
            case 5:
              return _context.a(2);
          }
        }, _callee, null, [[1, 3, 4, 5]]);
      }));
      return function initData() {
        return _ref2.apply(this, arguments);
      };
    }();
    return function (_ctx, _cache) {
      var _component_t_loading = _resolveComponent("t-loading");
      var _component_svg_icon = _resolveComponent("svg-icon");
      var _component_t_dialog = _resolveComponent("t-dialog");
      return _openBlock(), _createBlock(_component_t_dialog, {
        visible: _unref(visible),
        width: "470px",
        attach: "body",
        header: "选择需要批阅的习练",
        destroyOnClose: "",
        footer: false,
        onClose: hclose
      }, {
        default: _withCtx(function () {
          return [_createElementVNode("div", _hoisted_1, [isLoading.value ? (_openBlock(), _createBlock(_component_t_loading, {
            key: 0,
            class: "loading"
          })) : (_openBlock(), _createElementBlock(_Fragment, {
            key: 1
          }, [listData.value.length ? (_openBlock(), _createElementBlock("div", _hoisted_2, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(listData.value, function (item, index) {
            return _openBlock(), _createElementBlock("div", {
              class: _normalizeClass({
                'list-item': true,
                'is-viewed': item.isMark,
                active: activeIndex.value === index
              }),
              key: item.paperId,
              onClick: function onClick($event) {
                return changeItem(item, index);
              }
            }, [_createTextVNode(_toDisplayString(index + 1) + ". ", 1), _createElementVNode("span", _hoisted_4, _toDisplayString(item.title), 1), item.isMark ? (_openBlock(), _createElementBlock("span", _hoisted_5, "已批阅")) : _createCommentVNode("", true)], 10, _hoisted_3);
          }), 128))])) : _createCommentVNode("", true), isEmpty.value ? (_openBlock(), _createElementBlock("div", _hoisted_6, [_createVNode(_component_svg_icon, {
            name: "noData",
            size: "165"
          }), _cache[0] || (_cache[0] = _createElementVNode("span", null, "该学程未添加习练", -1))])) : (_openBlock(), _createElementBlock("div", _hoisted_7, "共" + _toDisplayString(listData.value.length) + " 项数据", 1))], 64))])];
        }),
        _: 1
      }, 8, ["visible"]);
    };
  }
};